import { render, staticRenderFns } from "./bottom-left.vue?vue&type=template&id=4fe845fb&scoped=true&"
import script from "./bottom-left.vue?vue&type=script&lang=js&"
export * from "./bottom-left.vue?vue&type=script&lang=js&"
import style0 from "./bottom-left.vue?vue&type=style&index=0&id=4fe845fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe845fb",
  null
  
)

export default component.exports